import { GetDeviceSnapshotDTO } from '@eppendorf/vnls-device-service-utils';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { TabsNavigationSidecar } from '$components/tabs';
import type { TabNavigationRoute } from '$components/tabs/tabs.types';
import {
  DEVICES_WITHOUT_PARAMETERS,
  DEVICES_WITTHOUT_HISTORY_CHARTS,
} from '$features/monitoring/shared/devices-without-parameters';

export function MonitoringDetailNavigation({
  snapshot,
}: {
  snapshot?: GetDeviceSnapshotDTO;
}): ReactElement {
  const { t } = useTranslation();

  const chart: TabNavigationRoute = {
    label: t('monitoringDetail.history-charts'),
    labelShort: t('monitoringDetail.history-charts-short'),
    path: 'history-charts-v2',
    icon: 'charts',
  };

  const monitoringDetailSidecarRoutes: TabNavigationRoute[] = [
    {
      label: t('monitoringDetail.parameters'),
      path: 'parameters',
      icon: 'parameter',
    },
    chart,
    {
      label: t('monitoringDetail.events'),
      path: 'events',
      icon: 'events',
    },
    {
      label: t('monitoringDetail.export'),
      path: 'export',
      icon: 'export',
    },
  ];

  // remove History Charts tab for devices without history charts
  if (
    snapshot &&
    DEVICES_WITTHOUT_HISTORY_CHARTS.includes(snapshot.inventoryDevice.model ?? '')
  ) {
    monitoringDetailSidecarRoutes.splice(1, 1);
  }

  // remove Parameters tab for devices without parameters
  if (
    snapshot &&
    DEVICES_WITHOUT_PARAMETERS.includes(snapshot.inventoryDevice.model ?? '')
  ) {
    monitoringDetailSidecarRoutes.splice(0, 1);
  }

  return <TabsNavigationSidecar routes={monitoringDetailSidecarRoutes} />;
}
